
export default class OnPremSiteToSiteVPNConfiguration {

    inboundEndpointType!: string;

	endpointLocation!: string;

	endpointIP!: string;

	vpnMode!: string;

	negotiationMode!: string;

	replyDetection!: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}